import Enumerable from "linq";
import { Directory, RootDirectory } from "../../../domain/drawing";
import { ITreeData } from "../../../domain/system";

export class DirectoryTreeNodesFactory<TKey, TEntity> {
  constructor(private _toEntityNode: (e: TEntity, i: number) => ITreeData<TKey, TEntity> = null) {
  }

  create(directories: Directory<TKey, TEntity>[]): ITreeData<TKey, TEntity>[] {
    return this.toDirectoryNodes(directories);
  }

  createFromRootDirectory(root: RootDirectory<TKey, TEntity>): ITreeData<TKey, TEntity>[] {
    if (!root) { return []; }
    return this.toDirectoryNodes(root.nodes, null).concat(this.toEntityNodes(root.entities, null));
  }

  private toDirectoryNodes(directories: Directory<TKey, TEntity>[], parent?: ITreeData<TKey, TEntity>): ITreeData<TKey, TEntity>[] {
    return Enumerable.from(directories)
      .select(d => this.toDirectoryNode(d, this.publishId(), parent)) // そのまま関数を渡すと関数に渡るthisはundefinedになってる.(Linq.jsの副作用？)
      .toArray();
  }

  private toDirectoryNode(directory: Directory<TKey, TEntity>, publishedId: number, parent?: ITreeData<TKey, TEntity>): ITreeData<TKey, TEntity> {
    const result: ITreeData<TKey, TEntity> = {
      id: publishedId,
      label: directory.name,
      iconClass: "tree-icon-directory",
      source: directory,
      parent,
    };
    result.children = this.toDirectoryNodes(directory.nodes, result)
      .concat(this.toEntityNodes(directory.entities, result));
    return result;
  }

  private toEntityNodes(entities: TEntity[], parent: ITreeData<TKey, TEntity>): ITreeData<TKey, TEntity>[] {
    return Enumerable.from(this.shouldCreateEntityNode ? entities : [])
      .select(e => this.toEntityNode(e, parent)) // そのまま関数を渡すと関数に渡るthisはundefinedになってる.(Linq.jsの副作用？)
      .toArray();
  }

  private toEntityNode(entity: TEntity, parent: ITreeData<TKey, TEntity>): ITreeData<TKey, TEntity> {
    const result = this._toEntityNode(entity, this.publishId());
    result.parent = parent;
    return result;
  }

  private get shouldCreateEntityNode(): boolean {
    return (this._toEntityNode !== null)
        && (this._toEntityNode !== undefined);
  }

  private publishId(): number {
    ++this._lastPublishedId;
    return this._lastPublishedId;
  }

  private _lastPublishedId: number = 0;
}
